import React, { useRef, useState } from 'react'

import { Followups } from "./Followups"
import { Notes } from "./Notes"
import { Meetings } from "./Meetings"
import { Documents } from "./Documents"
import { Col, Dropdown, Nav, Tab } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faEllipsisV, faPencil, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useOutsideClickHandler } from '../../../Utils/hooks/useOutsideClickHandler'
import { Quotation } from './Quotation'
import { toast } from 'sonner'

export const RightLeadDetailsPanel = ({
    leadId,
    onClose,
    onEdit,
    onDelete,
    leadData,
    leadDocGrant,
    leadGrant,
    canEdit_canDownload,
    followupGrant,
    leadMeetingGrant,
    leadNoteGrant,
    setCallLogOpen,
    // just to ensure if actions dropdown is to be shown necessarily or not
    isActionDropReqd
}) => {

    // Active tab state for lazy loading
    const [activeTab, setActiveTab] = useState("followups")

    // Dropdown state for three dots menu
    const [showActionsDropdown, setShowActionsDropdown] = useState(false)
    const actionsDropdownRef = useRef(null)


    // Close dropdowns on outside click
    useOutsideClickHandler({
        objRef: actionsDropdownRef,
        isDropdown: showActionsDropdown,
        setDropdown: setShowActionsDropdown
    })

    // Toggles actions dropdown menu
    const toggleActionsDropdown = () => setShowActionsDropdown((prev) => !prev)
    // Closes actions dropdown
    const closeActionsDropdown = () => setShowActionsDropdown(false)



    // Handles edit action
    const handleEdit = () => {
        if (onEdit && leadData) {
            onEdit(leadData.id)
        }
        closeActionsDropdown()
        onClose()
    }


    // Handles delete action
    const handleDelete = () => {
        if (onDelete && leadData) {
            onDelete(leadData.id)
        }
        closeActionsDropdown()
        onClose()
    }

    // Handles tab change and sets active tab for lazy loading
    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey)
    }
    return (
        <Col md={5} className="ps-2 contactInformation" style={{ height: "100%", paddingRight: 1 }}>
            <div style={{}} className="contactInformation">
                <Tab.Container defaultActiveKey="followups" onSelect={handleTabChange}>
                    <div className="card min-h-100 cardBorders" >
                        <div className="card-header d-flex justify-content-between align-items-center px-3 py-0 cardHeaderBorders">
                            <div style={styles.ulStyles}>
                                <div className="d-flex align-items-center gap-1 h-100">
                                    <Nav variant="pills" className="nav-style-1 mb-0 d-flex flex-nowrap navItemsBeforeStyle gap-2">
                                        <Nav.Item className="me-3" style={{ width: "65px" }}>
                                            <Nav.Link eventKey="followups" className="p-0">
                                                FollowUps
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="me-3">
                                            <Nav.Link eventKey="notes" className="p-0">
                                                Notes
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="me-3">
                                            <Nav.Link eventKey="meetings" className="p-0">
                                                Meetings
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="me-3">
                                            <Nav.Link eventKey="documents" className="p-0">
                                                Documents
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                    {/* Three dots menu */}
                                    {isActionDropReqd && (
                                        <div ref={actionsDropdownRef} className="position-relative">
                                            <Dropdown
                                                show={showActionsDropdown}
                                            >
                                                <button
                                                    type="button"
                                                    className="btn btn-default"
                                                    style={styles.listWhatsButtonsStyles}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowActionsDropdown(prev => !prev)
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faEllipsisV} style={styles.iconStyles} />
                                                </button>
                                                {showActionsDropdown &&
                                                    <Dropdown.Menu
                                                        className="defaultDropdown"
                                                        style={{
                                                            width: "10rem",
                                                            padding: "7px 0px",
                                                            display: "block",
                                                            position: "fixed",
                                                            top: actionsDropdownRef.current
                                                                ? actionsDropdownRef.current.getBoundingClientRect().bottom + window.scrollY
                                                                : 0,
                                                            left: actionsDropdownRef.current
                                                                ? actionsDropdownRef.current.getBoundingClientRect().right - 160 + window.scrollX
                                                                : 0,
                                                            zIndex: 9999,
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #dee2e6",
                                                            borderRadius: "0.375rem",
                                                            boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                                                        }}
                                                    >
                                                        <Dropdown.Item onClick={() => {
                                                            if (!leadGrant.isEdit && !canEdit_canDownload) {
                                                                toast.warning("You are not authorized for this action!")
                                                                return
                                                            }
                                                            if (!canEdit_canDownload) {
                                                                toast.warning("You are not authhorised for this action!")
                                                                return
                                                            }
                                                            handleEdit()
                                                        }} className="fs-13 d-flex gap-2 align-items-center">
                                                            <FontAwesomeIcon icon={faPencil} /> Edit Lead
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => {
                                                                if (!leadGrant.isDelete && !canEdit_canDownload) {
                                                                    toast.warning("You are not authorized for this action!")
                                                                    return
                                                                }
                                                                if (!canEdit_canDownload) {
                                                                    toast.warning("You are not authhorised for this action!")
                                                                    return
                                                                }
                                                                handleDelete()
                                                            }}
                                                            className="fs-13 d-flex gap-2 align-items-center"
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} /> Delete Lead
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => {
                                                                setCallLogOpen(true);
                                                            }}
                                                            className="fs-13 d-flex gap-2 align-items-center"
                                                        >
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                            Call Log
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                }
                                            </Dropdown>
                                        </div>
                                    )}
                                    {
                                        isActionDropReqd &&
                                        <>
                                            <div style={styles.emptyDivs}></div>
                                            <button
                                                type="button"
                                                className="btn btn-default"
                                                style={styles.listWhatsButtonsStyles}
                                                onClick={() => onClose()}
                                            >
                                                <FontAwesomeIcon icon={faXmark} style={styles.iconStyles} />
                                            </
                                            button>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Tab.Content>
                                <Tab.Pane
                                    eventKey="followups"
                                    style={{ border: "none", animation: "cardEntry 1s ease-out forwards" }}
                                >
                                    <Followups followupGrant={followupGrant} leadId={leadId} module_name={"lead"} isActive={activeTab === "followups"} />
                                </Tab.Pane>
                                <Tab.Pane
                                    eventKey="notes"
                                    style={{ border: "none", animation: "cardEntry 1s ease-out forwards" }}
                                >
                                    <Notes noteGrant={leadNoteGrant} leadId={leadId} isActive={activeTab === "notes"} module_name={"leads"} />
                                </Tab.Pane>
                                <Tab.Pane
                                    eventKey="meetings"
                                    style={{ border: "none", animation: "cardEntry 1s ease-out forwards" }}
                                >
                                    {
                                        leadData?.email &&
                                        <Meetings leadId={leadId} meetingGrant={leadMeetingGrant} isActive={activeTab === "meetings"} email={leadData?.email} fullName={leadData?.contact_name} module_name={"leads"} />
                                    }
                                </Tab.Pane>
                                <Tab.Pane
                                    eventKey="documents"
                                    style={{ border: "none", animation: "cardEntry 1s ease-out forwards", padding: 0, paddingTop: '20px' }}
                                >
                                    <Documents leadId={leadId} documentGrant={leadDocGrant} isActive={activeTab === "documents"} module_name={"leads"} />
                                </Tab.Pane>
                                <Tab.Pane
                                    eventKey="quotation"
                                    style={{ border: "none", animation: "cardEntry 1s ease-out forwards" }}
                                >
                                    <Quotation leadId={leadId} isActive={activeTab === "quotation"} />
                                </Tab.Pane>
                            </Tab.Content>
                        </div>
                    </div>
                </Tab.Container>
            </div>
        </Col>
    )
}

const styles = {
    bottomP: {
        fontSize: 11,
    },
    bottomH4: {
        marginBottom: 2,
    },
    buttons: {
        color: "#fff",
        fontSize: "13px",
        height: "34px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    filterbuttons: {
        fontSize: "13px",
        height: "33px",
        width: "33px",
        maxHeight: 33,
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    ulStyles: {
        display: "flex",
        alignItems: "center",
        gap: "3px",
        justifyContent: "space-between",
        width: "100%",
    },
    listButtonsStyles: {
        fontSize: "18px",
        height: "34px",
        width: "34px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    listWhatsButtonsStyles: {
        fontSize: "13px",
        height: "29px",
        gap: 5,
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    navButtonsStyles: {
        fontSize: "15px",
        height: "34px",
        minWidth: "34px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    iconStyles: {
        fontSize: 12,
        color: "#fff",
    },
    emptyDivs: {
        borderRight: "1px solid #E0E4F8",
        height: "35px",
        margin: "0px 2px",
    },
    DropdownItemsStyle: {
        fontSize: ".93re",
        letterSpacing: ".0386rem",
        fontWeight: 400,
        color: "#2e384d",
    },
    navLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    inActiveNavLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
        pointerEvents: "none",
    },
    tabContainer: {
        border: "1px solid #E0E4F8",
        borderRadius: "4px",
    },
    stickyHeader: {
        paddingBottom: "12px",
        paddingTop: "12px",
        position: "sticky",
        background: "#fff",
        top: "0px",
        background: "#fff",
        borderRadius: 0,
        borderBottom: "1px solid rgb(224, 228, 248)",
        borderTop: "1px solid rgb(224, 228, 248)",
        borderLeft: "1px solid rgb(224, 228, 248)",
        borderRight: "1px solid rgb(224, 228, 248)",
        zIndex: 1,
    },
    labels: {
        fontSize: "12px",
        color: "#B0BAC9",
        fontWeight: 400,
    },
    iconsStyles: {
        color: "#2656a8",
        border: "1px solid #e6e6e6",
        background: "#e9f1ff",
        padding: "8px",
        borderRadius: "50%",
        marginRight: "10px",
        width: "11px",
        height: "11px",
        fontSize: "13px",
    },
    values: {
        color: "#2e384d",
        fontWeight: 400,
        fontSize: ".8333rem",
        letterSpacing: "0.25px"
    },
    sectionTitle: {
        fontSize: "17px",
        fontWeight: 300,
        marginLeft: "14px",
        marginBottom: "19px",
    },
}

